import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function AgencyListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.drc.examinationResult.upload);
  };

  return (
    <MainMenuItem
      itemTitleString="検査結果を登録"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default AgencyListMenuItem;
